// src/utils/imageUtils.js

const API_BASE_URL = process.env.REACT_APP_API_URL 
  ? process.env.REACT_APP_API_URL.replace(/\/api$/, '') 
  : 'https://api.vtech-solution.com';

const cleanApiBaseUrl = (url) => {
  if (!url) return 'https://api.vtech-solution.com';
  let clean = url.replace(/\/$/, '');
  if (!clean.startsWith('http://') && !clean.startsWith('https://')) {
    clean = `https://${clean}`;
  }
  return clean;
};

const CLEANED_API_BASE_URL = cleanApiBaseUrl(API_BASE_URL);

/**
 * Universal Image URL Resolver
 * Standardizes relative upload paths, blob/data URIs, and external URLs.
 */
export const resolveImageUrl = (url) => {
  if (!url) return null;
  
  // ✅ CRITICAL FIX: If it's already a full http/https URL, return it immediately!
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // Only clean up double URLs from previous bugs, but NEVER rebuild them
    return url.replace('https://api.vtech-solution.comhttps://', 'https://api.vtech-solution.com/');
  }
  
  if (url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  
  let cleanUrl = url;
  cleanUrl = cleanUrl.replace(/^\.\//, '');
  
  // This part is ONLY for relative paths like '/uploads/...' or 'uploads/...'
  cleanUrl = cleanUrl.replace(/^\/api\//, '/');
  
  if (!cleanUrl.startsWith('/')) {
    cleanUrl = `/${cleanUrl}`;
  }
  
  cleanUrl = cleanUrl.replace(/\/api\/uploads/g, '/uploads');
  cleanUrl = cleanUrl.replace(/\/api\/images/g, '/images');
  cleanUrl = cleanUrl.replace(/\/api\/logos/g, '/logos');
  cleanUrl = cleanUrl.replace(/\/api\/profiles/g, '/profiles');
  cleanUrl = cleanUrl.replace(/\/\/+/g, '/');
  
  return `${CLEANED_API_BASE_URL}${cleanUrl}`;
};

/**
 * Get User Avatar URL
 * Checks user profile picture across admin/vendor object formats
 */
export const getUserAvatarUrl = (user) => {
  if (!user) return null;
  
  if (user.profileImage) {
    return resolveImageUrl(user.profileImage);
  }
  
  if (user.storeLogo) {
    return resolveImageUrl(user.storeLogo);
  }
  
  if (user.avatar) {
    return resolveImageUrl(user.avatar);
  }
  
  return null;
};

export default {
  resolveImageUrl,
  getUserAvatarUrl,
};